import React from 'react'
import ReactDOMClient from 'react-dom/client'
import { App } from '~components/App'

const container = document.getElementById('root')
const root = container && ReactDOMClient.createRoot(container)
root?.render(<App />)
